module.exports = __webpack_public_path__ + "img/10.d2974e11.jpg";